import React from 'react';
import { connect } from 'react-redux';
import StoreSync from '@bit/knotchinc.web-react-components.store-sync';
import CompanyTitle from 'components/Global/Breadcrumbs/CompanyTitle.jsx';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import Box from '@bit/knotchinc.web-react-components.box';
import Text from '@bit/knotchinc.web-react-components.text';
import ContentReportData from './ContentReportData.jsx';
import SocialData from './SocialData.jsx';
import KeywordData from './KeywordData.jsx';
import PublisherData from './PublisherData.jsx';
import BrandData from './BrandData.jsx';
import { fetchReportData } from '../actions.js';
import { Page } from './styled';

const BrandList = ({ report: { entities = [] } }) => <Box padding="200px 100px 150px 100px">
  <Text display="inline-block" color="white" width="10%" fontSize="10px" fontWeight="bold">BRANDS </Text>
  <Box display="inline-block" width="90%" verticalAlign="top" pl="60px">
    {entities.filter(entity => entity.type === 'brand').map(entity => <Box display="inline-block"><EntityItem data={entity} /></Box>)}
  </Box>
</Box>;

const Timeframe = () => <Box padding="0 100px">
  <Text display="inline-block" color="white" width="10%" fontSize="10px" fontWeight="bold">TIMEFRAME </Text>
  <Box display="inline-block" width="90%" verticalAlign="top" pl="60px" color="white">2019-01-01  →  2019-10-01</Box>
</Box>;

export class ReportPrintView extends React.Component {
  componentDidMount() {
    const { match, getData } = this.props;

    getData(match.params.reportId);
  }

  componentDidUpdate({ match: oldMatch }) {
    const { params: { reportId: oldReportId } } = oldMatch;
    const { match, getData } = this.props;

    if (match.params.reportId !== oldReportId) {
      getData(match.params.reportId);
    }
  }

  render() {
    const { report } = this.props;
    const { data = {} } = report;
    const { request = {} } = data;

    const type = request.report_type === 'brand' ? <PublisherData /> : <BrandData />;
    return (
      <React.Fragment>
        <Page background="linear-gradient(210.61deg, #446D93 -0.9%, #254461 101.44%)">
          <StoreSync stores={{ report }}>
            <Box p="100px">{CompanyTitle}</Box>
            <Text fontWeight="300" color="white" fontSize="50px" padding="0 100px">Lorem Ipsum Report Name Goes Here</Text>
            <BrandList />
            <Timeframe />
          </StoreSync>
        </Page>
        <div id="report-container">
          <StoreSync stores={{ report }}>
            <ContentReportData />
            <SocialData />
            <KeywordData />
            {type}
          </StoreSync>
        </div>
      </React.Fragment>);
  }
}

const mapStateToProps = ({
  Reports: { report }, Account: { isKnotchAdmin },
}) => ({ report, isKnotchAdmin });

const mapDispatchToProps = dispatch => ({
  getData: id => dispatch(fetchReportData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPrintView);
